import { type FC, type ReactNode, useState } from "react";

import {
  Box,
  ExtendedUpsellCard,
  Text,
  Column,
  Button,
  UpgradeIcon,
  type MarginProps,
} from "@hightouch/htui";

import { UpsellModal } from "./modal";
import type { FeatureProps } from "./types";

type FeatureFullProps = {
  enabled: boolean;
  featureName: string;
  featureDetails: FeatureProps;
  children: ReactNode;
  upsellCardMarginProps?: MarginProps;
  badgeText?: string;
  action?: ReactNode;
};

export const FeatureFull: FC<Readonly<FeatureFullProps>> = ({
  enabled,
  featureName,
  children,
  featureDetails,
  upsellCardMarginProps,
  badgeText = "Business Tier",
  action,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  // TODO: Add docs link
  const { pitch, bullets, description, video, image } = featureDetails;

  if (enabled) {
    return <>{children}</>;
  }

  return (
    <>
      <ExtendedUpsellCard
        {...upsellCardMarginProps}
        badgeText={badgeText}
        title={pitch}
        imageUrl={image?.src}
        videoPoster={video?.poster}
        videoUrl={video?.src}
        actions={
          action ?? (
            <Button icon={UpgradeIcon} onClick={() => setModalOpen(true)}>
              Unlock {featureName}
            </Button>
          )
        }
      >
        <Text color="text.secondary">{description}</Text>
        <Column as="ul" gap={2} mt={2} pl={6}>
          {bullets.map((bullet, idx) => (
            <Box key={idx} as="li">
              <Text color="text.secondary">{bullet}</Text>
            </Box>
          ))}
        </Column>
      </ExtendedUpsellCard>
      {!action && (
        <UpsellModal
          featureName={featureName}
          isOpen={modalOpen}
          onClose={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
